<!--
 * @Author: ext.chenghuan8
 * @Date: 2025-11-28 10:22:34
 * @LastEditors: ext.chenghuan8
 * @LastEditTime: 2025-12-01 16:00:47
 * @Description:
 * @contact_information: ext.chenghuan8@jd.com
-->
<template>
  <div class="card" style="width: 2.71rem; height: 1.22rem">
    <div class="card-header">
      <div>重要通知</div>
      <div class="more">更多</div>
    </div>
      <div class="info-column info-flex" v-for="(item,index) in 2" :key="index">
        <div class="tips">系统维护通知</div>
        <div class="time">本周六晚23:00:00~24:00:00进行系统维护，请提前做好工作安排。</div>
        <div class="hour">2小时前</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {}
  },
  computed: {},
  created () {},
  methods: {}
}
</script>
